<form class="co-form u-bg2" [formGroup]="form">
  <div class="c-wrapper--small">
    <h2 class="co-form__title">ご希望の条件を入力してください。</h2>
    @if (hasCity()) {
    <h3 class="co-form__name">{{ type() }}を検討している都市（複数選択可）<span>必須</span></h3>
    } @else {
    <h3 class="co-form__name">{{ type() }}を検討している国（複数選択可）<span>必須</span></h3>
    }
    <ul class="co-form__country p-pageSearch__drop --bgnone" id="countries">
      @for (country of countriesArray(); track country; let i = $index) {
      <li class="p-pageSearch__dropItem --4">
        <input type="checkbox" [id]="'country-'+i" name="checkbox01" [checked]="form.getRawValue().countries.includes(country)" (change)="countryChange($event)" [value]="country">
        <label [for]="'country-'+i">{{ country }}</label>
      </li>
      }
    </ul>
    @if (hasError(form.controls.countries, 'required') && hasCity()) {
    <mat-error>{{ type() }}を検討している都市を選択してください</mat-error>
    } @else if (hasError(form.controls.countries, 'required')) {
    <mat-error>{{ type() }}を検討している国を選択してください</mat-error>
    }
    <h3 class="co-form__name">{{ type() }}の予算<span>必須</span></h3>
    <div class="co-form__selectWrapper">
      <select class="co-form__select" name="budget" formControlName="budget" id="budget">
        <option disabled="" value="">選択してください</option>
        <option value="20-30万円">20-30万円</option>
        <option value="30-50万円">30-50万円</option>
        <option value="50-100万円">50-100万円</option>
        <option value="100-150万円">100-150万円</option>
        <option value="150万円以上">150万円以上</option>
        <option value="未定">未定</option>
      </select>
    </div>
    @if (hasError(form.controls.budget, 'required')) {
    <mat-error>予算を選択してください</mat-error>
    }
    <h3 class="co-form__name">現在の英語力<span>必須</span></h3>
    <div class="co-form__selectWrapper">
      <select class="co-form__select" name="skill" formControlName="skill" id="skill">
        <option disabled="" value="">選択してください</option>
        <option value="まったく話せなく聞き取れない">まったく話せなく聞き取れない</option>
        <option value="片言で話せて一部聞き取れる">片言で話せて一部聞き取れる</option>
        <option value="日常会話が可能">日常会話が可能</option>
        <option value="ビジネス会話が可能">ビジネス会話が可能</option>
      </select>
    </div>
    @if (hasError(form.controls.skill, 'required')) {
    <mat-error>現在の英語力を選択してください</mat-error>
    }
    <h2 class="co-form__title">お客様の情報を入力してください</h2>
    <h3 class="co-form__name">お名前（ふりがな）<span>必須</span></h3>
    <div class="co-form__lastfirst">
      <input class="co-form__text" type="text" formControlName="lastNameKana" placeholder="たなか" id="lastNameKana">
      <input class="co-form__text" type="text" formControlName="firstNameKana" placeholder="たろう" id="firstNameKana">
    </div>
    @if (hasError(form.controls.lastNameKana, 'required') || hasError(form.controls.firstNameKana, 'required')) {
    <mat-error>お名前（ふりがな）を入力してください</mat-error>
    }
    <h3 class="co-form__name">電話番号<span>必須</span></h3>
    <div>
      <input class="co-form__text" type="tel" formControlName="phoneNumber" placeholder="09012345678" id="phoneNumber">
    </div>
    @if (hasError(form.controls.phoneNumber, 'required')) {
    <mat-error>電話番号を入力してください</mat-error>
    }
    <h3 class="co-form__name">メールアドレス<span>必須</span></h3>
    <div>
      <input class="co-form__text" type="email" formControlName="email" placeholder="example@mail.com" id="email">
    </div>
    @if (hasError(form.controls.email, 'required')) {
    <mat-error>メールアドレスを入力してください</mat-error>
    }
    <div class="u-text-center">
      <div class="co-form__privacy">
        <input type="checkbox" id="agree" name="checkbox01" formControlName="agree"><label for="agree"></label><span><a href="https://ryugaku.yume-kana.com/policy/" target="_blank" rel="noopener noreferrer">利用規約・プライバシーポリシー</a>に同意する</span>
      </div>
      @if (hasError(form.controls.agree, 'required')) {
      <mat-error>利用規約・プライバシーポリシーへの同意は必須です</mat-error>
      }

      <button class="co-form__btn u-br-normal c-btn c-btn--ac1" type="button" name="submitConfirm" value="無料で診断する" (click)="submit()" [disabled]="sending()">無料で診断する</button>
    </div>
  </div>
</form>
